<div class="c4g-page-dropdown" [class.open]="open" [class.disabled]="disabled">
  <button class="c4g-page-dropdown-toggle" [disabled]="disabled" (click)="toggleDropdown()">
    {{ getDisplay(selected) }}
    <span class="c4g-page-dropdown-arrow">▼</span>
  </button>
  <div class="c4g-page-dropdown-list" *ngIf="open">
    <div class="c4g-page-dropdown-option"
         *ngFor="let value of values"
         [class.selected]="value === selected"
         (click)="selectValue(value)">
      {{ getDisplay(value) }}
    </div>
  </div>
</div>
